export default __webpack_public_path__ + "static/media/help.aedebf1f.svg";